// Foreground "horn" alert.
// HTMLAudioElement is far more permissive than Web Audio for delayed
// playback after a user gesture, especially on iOS Safari and mobile
// Chrome. We preload one <audio> element pointed at /horn.wav, unlock
// it with a silent play() on the first user gesture, then play it on
// every DR_PUSH.

const KEY = "dr_sound_on";

export function soundOn() {
  return localStorage.getItem(KEY) === "1";
}

export function setSoundOn(v) {
  localStorage.setItem(KEY, v ? "1" : "0");
}

let audioEl = null;
let unlocked = false;

function getAudio() {
  if (typeof window === "undefined") return null;
  if (!audioEl) {
    audioEl = new Audio("/horn.wav");
    audioEl.preload = "auto";
    audioEl.crossOrigin = "anonymous";
    audioEl.playsInline = true;
    // Ensure autoplay attempts don't throw uncaught rejections
    audioEl.addEventListener("error", () => {});
  }
  return audioEl;
}

export function primeAudioOnUserGesture() {
  if (typeof window === "undefined") return;
  const prime = async () => {
    if (unlocked) return;
    const a = getAudio();
    if (!a) return;
    try {
      // Silent unlock: set volume 0, play then immediately pause.
      // This satisfies the "user gesture required to play audio" rule
      // for all subsequent .play() calls in this session.
      a.volume = 0;
      await a.play();
      a.pause();
      a.currentTime = 0;
      a.volume = 1;
      unlocked = true;
      ["pointerdown", "touchstart", "keydown", "click"].forEach((ev) =>
        window.removeEventListener(ev, prime, true)
      );
    } catch (_) {
      // Some browsers throw on volume=0 play; try again on next gesture.
    }
  };
  ["pointerdown", "touchstart", "keydown", "click"].forEach((ev) =>
    window.addEventListener(ev, prime, { capture: true })
  );
}

export function playHorn() {
  if (!soundOn()) return;
  playHornForced();
}

// Fires the horn regardless of sound-on preference; use for critical alerts.
export function playHornForced() {
  const a = getAudio();
  if (!a) return;
  try {
    a.currentTime = 0;
    a.volume = 1;
    const p = a.play();
    if (p && typeof p.then === "function") p.catch(() => {});
  } catch (_) {
    // Fallback: rebuild the element and try once more
    audioEl = null;
    try {
      const a2 = getAudio();
      const p = a2 && a2.play();
      if (p && typeof p.then === "function") p.catch(() => {});
    } catch (_) {}
  }
}

// Backwards-compat aliases so older imports keep working.
export const playChaChing = playHorn;
export const playChaChingForced = playHornForced;
